<template>
  <!-- 得意先一覧 -->
  <div id="AppMasterListCustomer">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <div class="box" style="margin-left: 50px; margin-right: 50px;">
      <div class="columns">
        <div class="column">
          <label class="searchTitle label">得意先一覧</label>
        </div>
      </div>
      <!-- 一行目 -->
      <template :searchConditions="searchConditions">
        <div class="columns">
          <div class="column">
            <div class="field box is-floating-label">
              <label class="label">絞込条件</label>
              <div class="columns">
                <div class="column is-one-fourth">
                  <b-field label="得意先コード" labelPosition="on-border">
                    <b-input v-model="searchConditions.code"></b-input>
                  </b-field>
                </div>
                <div class="column is-one-fourth">
                  <b-field label="得意先名" labelPosition="on-border">
                    <b-input v-model="searchConditions.name"></b-input>
                  </b-field>
                </div>
                <div class="column is-one-fourth">
                  <b-field label="郵便番号" labelPosition="on-border">
                    <b-input v-model="searchConditions.postCode"></b-input>
                  </b-field>
                </div>
                <div class="column is-one-fourth">
                  <b-field label="電話番号" labelPosition="on-border">
                    <b-input v-model="searchConditions.phoneNumber"></b-input>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column is-one-fourth">
                  <b-field label="区分" labelPosition="on-border" class="checkboxButtonField">
                    <b-checkbox-button v-model="division" native-value="J72">患者</b-checkbox-button>
                    <b-checkbox-button v-model="division" native-value="ZZZ">医療機関</b-checkbox-button>
                  </b-field>
                </div>
                <div class="column">
                  <span style="color: red" v-if="isSearchConditionNull">検索条件を指定してください。</span>
                  <span style="color: red" v-if="isSearchConditionAll">全件検索となる為、検索条件を絞り込んでください。</span>
                  <b-button
                    style="float:right;"
                    class="button"
                    type="is-primary"
                    icon-right="filter"
                    native-type="button"
                    @click="search()"
                  >検索</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="columns">
        <div class="column">
          <b-field horizontal label="表示件数" style="float:right; white-space:nowrap;">
            <b-select position="is-right" v-model="perPage">
              <option value="100">100</option>
              <option value="200">200</option>
              <option value="500">500</option>
            </b-select>
          </b-field>
        </div>
      </div>
      <div>
        <b-table
          :data="data"
          :paginated="isPaginated"
          :per-page="perPage"
          :current-page.sync="currentPage"
          :pagination-simple="isPaginationSimple"
          :pagination-position="paginationPosition"
          :pagination-size="paginationSize"
          :default-sort-direction="defaultSortDirection"
          default-sort="name"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
        >
          <template slot-scope="props">
            <b-table-column field="code" label="得意先コード" sortable centered>{{ props.row.code }}</b-table-column>
            <b-table-column field="name" label="得意先名" sortable>{{ props.row.name }}</b-table-column>
            <b-table-column field="division" label="区分" sortable centered>{{ props.row.division }}</b-table-column>
            <b-table-column field="postCode" label="郵便番号" sortable>{{ props.row.postCode }}</b-table-column>
            <b-table-column field="address" label="住所" sortable>{{ props.row.address }}</b-table-column>
            <!-- <b-table-column field="categoryName" label="市区町村" sortable>{{ props.row.address2 }}</b-table-column> -->
            <b-table-column field="phoneNumber" label="電話番号" sortable>{{ props.row.phoneNumber }}</b-table-column>
            <b-table-column v-if="userInfo.roleId == roleMap.systemManager" field="locationRequired" label="位置情報取得" sortable>
              <span>
                <b-checkbox v-model="props.row.locationRequired">
                  位置情報必須
                </b-checkbox>
              </span>
              <b-field class="file" style="float:right">
                <b-button
                  class="button is-primary has-text-centered"
                  native-type="button"
                  v-on:click="setLocationRequired(props.row)"
                >
                  登録
                </b-button>
              </b-field>
            </b-table-column>
          </template>
        </b-table>
      </div>
    </div>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
const constUser = require("../utils/user");
var data = [];
export default {
  name: "AppMasterListProduct",
  methods: {
    search: function() {
      if (
        this.searchConditions.code ||
        this.searchConditions.name ||
        this.searchConditions.postCode ||
        this.searchConditions.phoneNumber ||
        this.division.length > 0
      ) {
        console.log("検索条件あり");
        this.isSearchConditionNull = false;
        if (
          !this.isLength(this.searchConditions.code) &&
          !this.isLength(this.searchConditions.name) &&
          !this.isLength(this.searchConditions.postCode) &&
          !this.isLength(this.searchConditions.phoneNumber)
        ) {
          this.isSearchConditionAll = true;
          return;
        }
        this.isSearchConditionAll = false;
        // 検索条件の整形
        if (this.division.length == 1) {
          this.searchConditions.division = this.division[0];
        } else {
          this.searchConditions.division = "";
        }
        // 検索実行
        var excuteApi = this.getCustomerListPOST;
        var successCallBack = this.getCustomerListSuccess;
        var errorCallBack = this.getCustomerListError;
        // WebAPI Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
      } else {
        console.log("検索条件未入力");
        this.isSearchConditionAll = false;
        this.isSearchConditionNull = true;
      }
    },
    getCustomerListPOST: function(client) {
      return client.apis.apiMaster.getCustomerListPOST({
        body: {
          code: this.searchConditions.code,
          name: this.searchConditions.name,
          division: this.searchConditions.division,
          postCode: this.searchConditions.postCode,
          phoneNumber: this.searchConditions.phoneNumber
        }
      });
    },
    getCustomerListSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.data = result.obj;
    },
    getCustomerListError: function(result) {
      this.showErrorMessage(result);
    },

    setLocationRequired: function(row) {
      this.target = row;
      let excuteApi = this.setLocationRequiredPOST;
      let successCallBack = this.setLocationRequiredPOSTSuccess;
      let errorCallBack = this.setLocationRequiredPOSTError;

      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setLocationRequiredPOST: function(client) {
      let req = {
        code: this.target.code,
        locationRequired: this.target.locationRequired,
      };
      return client.apis.apiMaster.setLocationRequiredPOST({
        body: req
      });
    },
    setLocationRequiredPOSTSuccess: function(result) {
      if (result.obj) {
        this.showSuccess(result);
      }
      this.target = null;
      // 再検索
      this.search(this.searchConditions);
      return;
    },
    setLocationRequiredPOSTError: function(result) {
      this.showErrorMessage(result);
      this.target = null;
    },
  },
  data() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));

    return {
      data,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 100,
      isSearchConditionNull: false,
      isSearchConditionAll: false,
      searchConditions: {
        code: "",
        name: "",
        postCode: "",
        phoneNumber: "",
        division: ""
      },
      division: [],
      userInfo,
      roleMap: constUser.ROLE_ID_MAP,
      target: null,
    };
  },
  mounted: function() {
    // WebApi Call
    this.search(this.searchConditions);
  },
  filters: {},
  components: {}
};
</script>



// WEBPACK FOOTER //
// src/components/AppMasterListCustomer.vue